import { FC, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAuthentication } from '@connect-x-app/hybrid-state';
import { ConnectPermission } from '@connect-x-app/shared-domain-models';
import { FontSize } from '@connect-x-app/shared-ui';

import { TabBar } from '../../routing/tabbar/TabBar';

export type Tab = {
  label: string;
  name: string;
  order: number;
  permissions: ConnectPermission[];
  url: string;
};

type Props = {
  navBarClassName?: 'top-nav-bar' | 'nav-bar';
  tabs: Tab[];
  textSize?: FontSize;
};

export const TabRouter: FC<Props> = ({ navBarClassName = 'nav-bar', tabs, textSize = 'MD' }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasAllPermissions } = useAuthentication();

  const routes = useMemo(() => {
    return tabs.filter(tab => hasAllPermissions(tab.permissions)).sort((a, b) => a.order - b.order);
  }, [hasAllPermissions, tabs]);

  const onSetTab = (tab: number) => {
    const route = routes[tab];
    navigate(route.url);
  };

  const selectedTab = useMemo(() => {
    const tabIndex = routes.findIndex(({ url }) => location.pathname.startsWith(url));
    return tabIndex === -1 ? 0 : tabIndex;
  }, [location.pathname, routes]);

  return (
    <TabBar
      currentPage={selectedTab}
      navBarClassName={navBarClassName}
      setTab={onSetTab}
      tabRoutes={routes}
      textSize={textSize}
    />
  );
};
